import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IAiActions, IThunkOnUpdateAiSystemSettings } from '../types';

const onUpdateAiSystemSettings: IThunkOnUpdateAiSystemSettings = thunk(
  async ({ setAiSystemSettings }: Actions<IAiActions>, payload) => {
    await api.ai.updateAiSettings(payload);

    setAiSystemSettings(payload);
  },
);

export default onUpdateAiSystemSettings;
